import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, DollarSign, Zap, Calendar } from 'lucide-react';
import BusinessOpportunity from './BusinessOpportunity';
import ScheduleDemoDialog from './ScheduleDemoDialog';
import { handleScrollReset } from '@/utils/navigationUtils';

const VideoHeader: React.FC = () => {
  const [isScheduleDialogOpen, setIsScheduleDialogOpen] = useState(false);
  
  return (
    <div>
      <div className="relative h-[70vh] overflow-hidden bg-gradient-to-r from-indigo-50 to-blue-50">
        <div className="absolute inset-0 w-full h-full">
          <div className="absolute inset-0 bg-black/10 z-10"></div>
          <img src="/assets/5df22fbf-46c0-422b-a964-30ad729c926d.png" alt="Referral Business Illustration" className="w-full h-full object-contain" />
        </div>
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
          <ArrowRight className="h-10 w-10 text-primary-blue transform rotate-90" />
        </div>
      </div>

      <div className="container mx-auto px-4 py-10 text-center bg-white">
        <h1 className="text-4xl md:text-6xl font-bold mb-4 max-w-4xl mx-auto">
          <span className="block text-black">Launch Your Own</span>
          <span className="block text-primary-blue">Referral Business</span>
        </h1>
        
        <div className="animate-fade-in bg-white/90 p-8 rounded-xl w-full max-w-4xl mx-auto shadow-lg mt-8">
          <p className="text-xl md:text-2xl mb-4 max-w-3xl mx-auto text-gray-800">
            Earn up to $42,480 monthly reselling white-labeled referral programs to businesses
          </p>
          <p className="text-lg mb-8 max-w-3xl mx-auto text-gray-700">Get 300 referral accounts per node with just $499 setup fee.  No monthly recurring overhead just share revenue. Earn 20-45% of monthly recurring revenue.</p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/business-reseller-order" onClick={handleScrollReset}>
              <Button size="lg" className="bg-primary-blue text-white hover:bg-blue-600 px-6 py-5 text-lg">
                <DollarSign className="mr-2 h-5 w-5" />
                Signup Reseller Plan
              </Button>
            </Link>
            <a href="/saas-reseller" target="_blank" rel="noopener noreferrer" onClick={handleScrollReset}>
              <Button size="lg" variant="outline" className="border-primary-blue text-primary-blue hover:bg-primary-blue/10 px-6 py-5 text-lg">
                <Zap className="mr-2 h-5 w-5" />
                Reseller Plan Info
              </Button>
            </a>
          </div>
          
          <div className="mt-6">
            <Button 
              size="lg" 
              variant="gradient" 
              className="px-6 py-5 text-lg shadow-md hover:shadow-lg transition-all duration-300"
              onClick={() => setIsScheduleDialogOpen(true)}
            >
              <Calendar className="mr-2 h-5 w-5" />
              Schedule Demo
            </Button>
            <p className="text-sm text-gray-500 mt-2">
              Book a personalized demo with our team to see how the platform works
            </p>
          </div>
        </div>
      </div>

      <ScheduleDemoDialog 
        open={isScheduleDialogOpen} 
        onOpenChange={setIsScheduleDialogOpen} 
      />

      <BusinessOpportunity />
    </div>
  );
};

export default VideoHeader;
